import {Injectable} from '@angular/core';
import {PartnerClientListVO, PartnerClientVO} from './partner-client.interfaces';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {CrudEffects} from '@abydos-angular/store';
import {partnerClientDefinition} from './partner-client.reducers';
import {PartnerClientRepository} from './partner-client.repository';

@Injectable()
export class PartnerClientEffects extends CrudEffects<PartnerClientVO, PartnerClientListVO> {

    /*
      Minta Effect
      SampleEffect = createEffect(() => this.actions.pipe(
        ofType({{action_type}}),
        switchMap(() => {
          return this.crudRepository.fgv().pipe(
            map((payload) => {
              return {payload: payload};
            })
            , toActionCreatorPayload(result_action, HandleErrorAction)
          );
        })
      )
    );
    */
    constructor(actions: Actions, private partnerClientRepository: PartnerClientRepository) {
        super(actions, partnerClientRepository, partnerClientDefinition);
    }
}
